import commands from "../json/commands"
import Immutable from "immutable"

//Setting default vals
var commandType
for (commandType in commands){
    var command;
    for(command in commands[commandType]){
        commands[commandType][command].executeOn = 0;
    }
}

var immutableCommands = Immutable.fromJS(commands)

const actionList = (state = immutableCommands, action) => {
    switch (action.type) {
        case 'FILTER_ACTION_LIST':
            //console.log(state.flatten(1).keySeq().filter(x  => x.toUpperCase().includes(action.filterString.toUpperCase())))
            return immutableCommands.map((k =>
                    k.filter((k2, v2) => v2.toUpperCase().includes(action.filterString.toUpperCase()))
                ))
        case 'ADD_ACTION':
        case 'REMOVE_ACTION':
        case 'TOGGLE_ACTION':
        case 'ADD_ACTION_GROUP':
        case 'REMOVE_ACTION_GROUP':
        default:
            return state;
    }
}
export default actionList

